'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_RegisterPageView$$anon$14() {
  this.bty = null;
  this.btz = false;
}
export { $c_Lpresto_RegisterPageView$$anon$14 as $c_Lpresto_RegisterPageView$$anon$14 };
$p = $c_Lpresto_RegisterPageView$$anon$14.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_RegisterPageView$$anon$14;
/** @constructor */
function $h_Lpresto_RegisterPageView$$anon$14() {
}
export { $h_Lpresto_RegisterPageView$$anon$14 as $h_Lpresto_RegisterPageView$$anon$14 };
$h_Lpresto_RegisterPageView$$anon$14.prototype = $p;
$p.P = (function() {
  if ((!this.btz)) {
    this.bty = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_T4($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Some($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Seq$().aD()), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Some($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Seq$().aD()));
    this.btz = true;
  }
  return this.bty;
});
var $d_Lpresto_RegisterPageView$$anon$14 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_RegisterPageView$$anon$14, "presto.RegisterPageView$$anon$14", ({
  PW: 1,
  a: 1,
  i: 1
}));
export { $d_Lpresto_RegisterPageView$$anon$14 as $d_Lpresto_RegisterPageView$$anon$14 };
//# sourceMappingURL=presto.-Register-Page-View$$anon$14.js.map
